import { Helpers } from '../../helpers';
import { IOilTransportationType } from '../../interfaces/ioil-transportation-type';
import { TankBattery } from '../tank-battery';

export class OilTransportationTypeBase {
  OilTransportationTypeId: number;
  Description: string | null;
  Abbreviation: string | null;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  TankBatteries_OilTransportationType?: Array<TankBattery> | null;

  constructor(item?: IOilTransportationType) {
    if (item) {

      this.OilTransportationTypeId = item.OilTransportationTypeId;
      this.Description = item.Description;
      this.Abbreviation = item.Abbreviation;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.TankBatteries_OilTransportationType = Helpers.createClassArray(TankBattery, item.TankBatteries_OilTransportationType);
    }
  }
}